import { Link } from "react-router-dom";
import useUser from "../hooks/user/useUser";

const ADMIN_SECTIONS = [
    { to : 'notifications' , icon : 'bi-bell' , title : 'Notificaciones' , description : 'Enviá push y WhatsApp a los usuarios' },
    { to : 'sales' , icon : 'bi-cash-coin' , title : 'Ventas' , description : 'Cargá y revisá las ventas reportadas' },
    { to : 'appraisals' , icon : 'bi-clipboard-data' , title : 'Tasaciones' , description : 'Gestioná los pedidos de tasación' },
    { to : 'services/notarial' , icon : 'bi-file-earmark-text' , title : 'Servicios Notariales' , description : 'Solicitudes de servicios notariales' },
    { to : 'price-extractions' , icon : 'bi-filetype-pdf' , title : 'Extracciones de Precios' , description : 'Extraé precios desde listas y brochures' },
    { to : 'ranking' , icon : 'bi-trophy' , title : 'Ranking' , description : 'Ordená el ranking del feed' },
    { to : 'reportes' , icon : 'bi-bar-chart-line' , title : 'Reportes' , description : 'Reportes HTML custom de marketing' },
    { to : 'users/change-password' , icon : 'bi-key' , title : 'Cambiar contraseña' , description : 'Reseteá la clave de un usuario' },
]

const Admin = () =>{
    const {userState} = useUser()
    return (
        <main className="admin-home">
            <div className="admin-home-header">
                <span className="admin-home-kicker">Panel de administración</span>
                <h2>Hola, {userState.name?.trim()} 👋</h2>
                <p className="text-muted mb-0">¿Qué querés gestionar hoy?</p>
            </div>

            <div className="admin-home-grid">
                {
                    ADMIN_SECTIONS.map(section => (
                        <Link to={section.to} className="admin-tile" key={section.to}>
                            <span className="admin-tile-icon">
                                <i className={`bi ${section.icon}`}></i>
                            </span>
                            <span className="admin-tile-title">{section.title}</span>
                            <span className="admin-tile-description">{section.description}</span>
                            <i className="bi bi-arrow-right admin-tile-arrow"></i>
                        </Link>
                    ))
                }
            </div>
        </main>
    )
}
export default Admin
